/* Store Builder, Oct 17 2026 rebuild.
   Old version posted the email by AJAX to /contact. Shopify's bot check silently
   blocked it, the success popup showed anyway, and zero signups were ever saved.
   Now: the form submits natively (survives the bot check), the email lands in
   Customers tagged newsletter+popup, and the code is auto-applied via /discount/. */
class PromoPopup {
  constructor(container) {
    this.container = container;
    this.popupModal = container.querySelector('.sign-up-popup-modal');
    this.overlay = container.querySelector('.sign-up-popup-overlay');
    this.closeButton = this.popupModal.querySelector('.popup-modal__close');
    this.dismissButton = this.popupModal.querySelector('.popup-modal__dismiss-btn');
    this.form = this.popupModal.querySelector('form.newsletter-form');
    this.emailInput = this.form ? this.form.querySelector('input[type="email"]') : null;
    this.formError = this.form ? this.form.querySelector('.newsletter-form__message') : null;
    this.successModal = container.querySelector('.success-popup-modal');
    this.successOverlay = container.querySelector('.success-popup-overlay');
    this.copyButton = this.successModal ? this.successModal.querySelector('.popup-modal__copy-btn') : null;
    this.copySuccessMsg = this.successModal ? this.successModal.querySelector('.popup-modal__success-msg') : null;
    this.sectionId = this.popupModal.dataset.sectionId;
    this.discountCode = (this.popupModal.dataset.discountCode || '').trim();
    this.testMode = this.popupModal.dataset.testMode === 'true';
    this.delaySeconds = parseInt(this.popupModal.dataset.delaySeconds, 10) || 15;
    this.delayDays = parseInt(this.popupModal.dataset.delayDays, 10) || 14;
    this.displayTimer = this.popupModal.dataset.displayTimer === 'true';
    this.timerDuration = (parseFloat(this.popupModal.dataset.timerDuration) || 3) * 60;
    this.minutesElement = this.popupModal.querySelector('.popup-modal__timer__minutes');
    this.secondsElement = this.popupModal.querySelector('.popup-modal__timer__seconds');
    this.host = window.location.host;
    this.storageKey = 'promo-popup-' + this.host + '-' + this.sectionId;
    this.subKey = 'promo-bar-subscribed-' + this.host;
    this.pendingKey = 'pp-popup-pending-' + this.host;
    this.init();
  }

  read(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  write(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  drop(k) { try { localStorage.removeItem(k); } catch (e) {} }

  init() {
    this.setupEventListeners();
    if (this.form) this.setupForm();
    if (this.testMode) {
      if (this.displayTimer) this.startTimer();
      return;
    }

    var pending = null;
    try { pending = JSON.parse(this.read(this.pendingKey) || 'null'); } catch (e) { pending = null; }
    var fresh = pending && (Date.now() - pending.t) < 30 * 60 * 1000;
    var posted = !!(this.form && this.form.querySelector('.pp-posted')) || /[?&]customer_posted=true/.test(window.location.search);
    var errored = !!(this.form && this.form.querySelector('.pp-error'));

    if (fresh && posted && !errored) {
      this.drop(this.pendingKey);
      this.write(this.subKey, JSON.stringify({ subscribed: true }));
      this.applyCode();
      this.showSuccessPopup();
      return;
    }
    if (fresh && errored) {
      this.drop(this.pendingKey);
      this.showPopup();
      return;
    }
    this.checkAndShowPopup();
  }

  applyCode() {
    if (!this.discountCode) return;
    try {
      fetch('/discount/' + encodeURIComponent(this.discountCode) + '?redirect=%2Fcart.js', { credentials: 'same-origin' }).catch(function () {});
    } catch (e) {}
  }

  setupEventListeners() {
    var self = this;
    this.closeButton.addEventListener('click', function () { self.closePopup(); });
    if (this.dismissButton) this.dismissButton.addEventListener('click', function () { self.closePopup(); });
    this.overlay.addEventListener('click', function () { self.closePopup(); });
    if (this.successModal) {
      if (this.copyButton) this.copyButton.addEventListener('click', function () { self.handleCopyCode(); });
      this.successModal.querySelectorAll('.popup-modal__close, .popup-modal__dismiss-btn').forEach(function (b) {
        b.addEventListener('click', function () { self.closeSuccessPopup(); });
      });
      if (this.successOverlay) this.successOverlay.addEventListener('click', function () { self.closeSuccessPopup(); });
    }
  }

  isValidEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }

  setupForm() {
    var self = this;
    this.form.addEventListener('submit', function (e) {
      var email = (self.emailInput && self.emailInput.value || '').trim();
      if (!self.isValidEmail(email)) {
        e.preventDefault();
        self.showFormError('Please enter a valid email address.');
        return;
      }
      self.write(self.pendingKey, JSON.stringify({ t: Date.now() }));
    });
  }

  calculateNextDisplayDate() {
    return new Date(Date.now() + this.delayDays * 86400000).toISOString();
  }

  checkAndShowPopup() {
    if (this.read(this.subKey)) return;
    var stored = this.read(this.storageKey);
    if (stored) {
      try {
        var next = new Date(JSON.parse(stored).next_display_date);
        if (next > new Date()) return;
      } catch (e) {}
    }
    var self = this;
    setTimeout(function () { self.showPopup(); }, this.delaySeconds * 1000);
  }

  showPopup() {
    this.popupModal.classList.add('popup-modal--active');
    this.overlay.classList.add('popup-overlay--active');
    if (this.displayTimer) this.startTimer();
  }

  closePopup() {
    this.popupModal.classList.remove('popup-modal--active');
    this.overlay.classList.remove('popup-overlay--active');
    if (!this.testMode) {
      this.write(this.storageKey, JSON.stringify({ next_display_date: this.calculateNextDisplayDate(), dismissed: false }));
    }
  }

  showSuccessPopup() {
    if (!this.successModal) return;
    this.popupModal.classList.remove('popup-modal--active');
    this.overlay.classList.remove('popup-overlay--active');
    this.successModal.classList.add('popup-modal--active');
    if (this.successOverlay) this.successOverlay.classList.add('popup-overlay--active');
  }

  closeSuccessPopup() {
    if (!this.successModal) return;
    this.successModal.classList.remove('popup-modal--active');
    if (this.successOverlay) this.successOverlay.classList.remove('popup-overlay--active');
  }

  handleCopyCode() {
    var input = this.successModal.querySelector('#DiscountCode--' + this.sectionId);
    if (!input) return;
    var text = input.value;
    var done = this.copySuccessMsg;
    var show = function () {
      if (!done) return;
      done.style.display = 'block';
      setTimeout(function () { done.style.display = 'none'; }, 3000);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(show).catch(function () { input.select(); try { document.execCommand('copy'); } catch (e) {} show(); });
    } else {
      input.select();
      try { document.execCommand('copy'); } catch (e) {}
      show();
    }
  }

  showFormError(message) {
    if (!this.formError) return;
    var el = this.formError;
    el.textContent = message;
    el.style.display = 'block';
    setTimeout(function () { el.style.display = 'none'; }, 5000);
  }

  startTimer() {
    if (!this.minutesElement || !this.secondsElement) return;
    var self = this;
    var left = this.timerDuration;
    var tick = function () {
      var m = Math.floor(left / 60), s = Math.floor(left % 60);
      self.minutesElement.textContent = String(m).padStart(2, '0');
      self.secondsElement.textContent = String(s).padStart(2, '0');
      if (left > 0) { left--; setTimeout(tick, 1000); } else { self.closePopup(); }
    };
    tick();
  }
}

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-section-type="newsletter-popup"]').forEach(function (el) {
    new PromoPopup(el.closest('section, .shopify-section'));
  });
});
